export default __webpack_public_path__ + "static/media/paypal-logo.5ed61838.png";